import React, { useState, useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Redirect } from 'react-router-dom'
import HeroSection from './HeroSection'
import { PublicLandingPage } from './User/PublicLandingPage'

export default function Home({ isDarkMode }) {
  const [profileComplete, setProfileComplete] = useState(null)
  const [profileCheckFailed, setProfileCheckFailed] = useState(false)
  const [loading, setLoading] = useState(true)
  const { isAuthenticated, getAccessTokenSilently } = useAuth0()
  const apiUrl = process.env.REACT_APP_API_URL

  useEffect(() => {
    const checkProfile = async () => {
      if (!isAuthenticated) {
        setProfileComplete(null)
        setProfileCheckFailed(false)
        setLoading(false)
        return
      }

      if (isAuthenticated) {
        try {
          const token = await getAccessTokenSilently({
            authorizationParams: {
              audience: process.env.REACT_APP_API_AUDIENCE,
            }
          })

          const response = await fetch(`${apiUrl}/api/users/check-profile`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })

          if (!response.ok) {
            throw new Error(`Profile check failed (${response.status})`)
          }

          const profileComplete = await response.json()
          if (typeof profileComplete !== 'boolean') {
            throw new Error('Profile check returned an invalid response.')
          }

          setProfileComplete(profileComplete)
          setProfileCheckFailed(false)
        } catch (error) {
          console.error("Error fetching profile:", error)
          setProfileCheckFailed(true)
        }
        setLoading(false)
      }
    }

    checkProfile()
  }, [isAuthenticated, getAccessTokenSilently, apiUrl])

  if (loading) {
    return <div>Loading...</div>
  }

  if (!isAuthenticated) {
    return <PublicLandingPage />
  }

  if (profileComplete === false && isAuthenticated && !loading && !profileCheckFailed) {
    return <Redirect to="/profile-setup" />
  }

  return (
    <>
      {/* New Unified Hero, Cards, Gamify, Globe section */}
      <HeroSection isAuthenticated={isAuthenticated} />
    </>
  )
}
